import { CarbonIconType, Help16 } from '@carbon/icons-react';
import { v4 as uuidv4 } from 'uuid';
import { Section } from 'routes/settings/permissions/permission-reducer';

export const permissionSectionKeys = {
  projects: 'Projects',
  phase: 'Phase',
  projectFields: 'Project Fields',
  statusUpdates: 'Status Updates',
  keyEventsAndIntervals: 'Key events and Intervals',
  tasks: 'Tasks',
  taskFields: 'Task Fields',
  teamMemberFields: 'Team member Fields',
  spaces: 'Spaces',
  chat: 'Chat',
  dashboards: 'Dashboards',
  settings: 'Settings',
  financials: 'Financials',
  templates: 'Templates',
  folders: 'Folders',
  reports: 'Reports',
  timesheets: 'Timesheets',
  resourceManagement: 'Resource Management',
};

export const permissionSectionKeysForProjectLevelPermission = {
  projects: 'Projects',
  phase: 'Phase',
  tasks: 'Tasks',
  spaces: 'Spaces',
  chat: 'Chat',
  statusUpdates: 'Status Updates',
  keyEventsAndIntervals: 'Key events and Intervals',
  financials: 'Financials',
  folders: 'Folders',
  reports: 'Reports',
};

export const permissionSectionKeysForCustomerLevelPermission = {
  projects: 'Projects',
  phase: 'Phase',
  tasks: 'Tasks',
  spaces: 'Spaces',
  chat: 'Chat',
};

export enum NewPermissionSetTypes {
  AccountLevel = 'Account',
  ProjectLevel = 'Project',
  CustomerLevel = 'Customer',
}

export type NavItems = {
  menuName: string;
  menuIcon: CarbonIconType;
  route: string;
};

// !DANGER:  please don't change anything in this file. If you add/remove something from this data please ensure that all the ids are unique

export const actualDataToRenderForPermissionCreationScreen: Section[] = [
  // Projects
  {
    sectionHeaderName: 'projects.title',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.can_create_project',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            isSelected: true,
            permissionLevel: 'ACCOUNT',
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.view.can_view_projects',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            isSelected: true,
            permissionLevel: 'PROJECT',
            isDependentOn: [2, 3], // index of the dependent field,
            scopeModalOptions: [
              {
                id: uuidv4(),
                modalTitle: 'settings.permission.menu.title',
                fields: [
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.view.can.view_projects.global_access',
                    permissionSubTitle:
                      'permission.view.can.view_projects.global_access.subtitle',
                    type: 'radio',
                    requestScope: 'GLOBAL',
                    isSelected: true,
                  },
                  {
                    id: uuidv4(),
                    permissionTitle: 'permission.view.can.view_projects.group',
                    permissionSubTitle:
                      'permission.view.can.view_projects.group.subtitle',
                    type: 'radio',
                    requestScope: 'GROUP',
                    isSelected: false,
                  },
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.view.can.view_projects.participant_and_all',
                    permissionSubTitle:
                      'permission.view.can.view_projects.participant_and_all.subtitle',
                    type: 'radio',
                    requestScope: 'LESS_RESTRICTED',
                    isSelected: false,
                  },
                ],
              },
            ],
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.edit.can_edit_projects',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            isSelected: true,
            permissionLevel: 'PROJECT',
            dependentField: 1,
            // scopeModalOptions: {
            //   modalTitle: 'settings.permission.menu.title',
            //   fields: [
            //     {
            //       id: uuidv4(),
            //       permissionTitle:
            //         'permission.view.can.view_projects.global_access',
            //       permissionSubTitle:
            //         'permission.view.can.view_projects.global_access.subtitle',
            //       type: 'radio',
            //       requestScope: 'GLOBAL',
            //       isSelected: true,
            //     },
            //     {
            //       id: uuidv4(),
            //       permissionTitle: 'permission.view.can.view_projects.group',
            //       permissionSubTitle:
            //         'permission.view.can.view_projects.group.subtitle',
            //       type: 'radio',
            //       requestScope: 'GROUP',
            //       isSelected: false,
            //     },
            //     {
            //       id: uuidv4(),
            //       permissionTitle:
            //         'permission.view.can.view_projects.participant_and_all',
            //       permissionSubTitle:
            //         'permission.view.can.view_projects.participant_and_all.subtitle',
            //       type: 'radio',
            //       requestScope: 'LESS_RESTRICTED',
            //       isSelected: false,
            //     },
            //   ],
            // },
            children: [
              {
                id: uuidv4(),
                permissionTitle: 'permission.edit.can_invite_team_members',
                permissionSubTitle: '',
                type: 'checkbox',
                takeActionScopeFromItself: true,
                permissions: [
                  {
                    permissionName: 'PROJECT_MEMBER:CREATE',
                    requestScope: 'GLOBAL',
                    actionScopes: ['NATIVE', 'PARTNER'],
                  },
                  // {
                  //   permissionName: 'PROJECT_MEMBER:CREATE',
                  //   requestScope: 'GLOBAL',
                  //   actionScopes: [],
                  // },
                  // {
                  //   permissionName: 'PROJECT_MEMBER:DELETE',
                  //   requestScope: 'GLOBAL',
                  //   actionScopes: [],
                  // },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.edit.can_invite_customer_team_members',
                permissionSubTitle: '',
                type: 'checkbox',
                takeActionScopeFromItself: true,
                permissions: [
                  {
                    permissionName: 'PROJECT_MEMBER:CREATE',
                    requestScope: 'GLOBAL',
                    actionScopes: ['EXTERNAL'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.edit.can_add_partners',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PROJECT_PARTNER:CREATE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                  // {
                  //   permissionName: 'PROJECT_PARTNER:DELETE',
                  //   requestScope: 'GLOBAL',
                  //   actionScopes: [],
                  // },
                  // {
                  //   permissionName: 'PROJECT_PARTNER:WRITE',
                  //   requestScope: 'GLOBAL',
                  //   actionScopes: [],
                  // },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.edit.can_set_visibility',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PROJECT_VISIBILITY:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.delete.can_delete_projects',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            isSelected: true,
            permissionLevel: 'PROJECT',
            dependentField: 1,
            // scopeModalOptions: {
            //   modalTitle: 'settings.permission.menu.title',
            //   fields: [
            //     {
            //       id: uuidv4(),
            //       permissionTitle:
            //         'permission.view.can.view_projects.global_access',
            //       permissionSubTitle:
            //         'permission.view.can.view_projects.global_access.subtitle',
            //       type: 'radio',
            //       requestScope: 'GLOBAL',
            //       isSelected: true,
            //     },
            //     {
            //       id: uuidv4(),
            //       permissionTitle: 'permission.view.can.view_projects.group',
            //       permissionSubTitle:
            //         'permission.view.can.view_projects.group.subtitle',
            //       type: 'radio',
            //       requestScope: 'GROUP',
            //       isSelected: false,
            //     },
            //     {
            //       id: uuidv4(),
            //       permissionTitle:
            //         'permission.view.can.view_projects.participant_and_all',
            //       permissionSubTitle:
            //         'permission.view.can.view_projects.participant_and_all.subtitle',
            //       type: 'radio',
            //       requestScope: 'LESS_RESTRICTED',
            //       isSelected: false,
            //     },
            //   ],
            // },
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: '',
        headerName: 'permission.project.team_member_permissions',
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.project.can_associate_project_permissions',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'ASSOCIATE_PROJECT_PERMISSION:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            isSelected: true,
            permissionLevel: 'PROJECT',
            takeRequestScopeFromChild: true,
            takeActionScopeFromItself: true,
            children: [
              // {
              //   id: uuidv4(),
              //   permissionTitle: 'permission.project.permissions.all_projects',
              //   permissionSubTitle:
              //     'permission.project.permissions.all_projects_subtitle',
              //   type: 'radio',
              //   permissions: [
              //     {
              //       permissionName: '',
              //       requestScope: 'GLOBAL',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'GLOBAL',
              //   permissionLevel: 'ACCOUNT',
              //   isSelected: true,
              // },
              // {
              //   id: uuidv4(),
              //   permissionTitle:
              //     'permission.project.permissions.select_project_permissions',
              //   permissionSubTitle:
              //     'permission.project.permissions.select_project_permissions_subtitle',
              //   type: 'radio',
              //   permissions: [
              //     {
              //       permissionName: '',
              //       requestScope: 'RESTRICTED',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'RESTRICTED',
              //   permissionLevel: 'ACCOUNT',
              //   isSelected: false,
              //   showMultiSelect: {
              //     type: 'projectPermissions',
              //     selectedOptions: [],
              //   },
              // },
            ],
          },
        ],
      },
    ],
  },
  // Phase
  {
    sectionHeaderName: 'phase',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.phase.can_create_phase',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PHASE:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            permissionLevel: 'PROJECT',
            requestScope: 'GLOBAL',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.phase.can_set_visibility',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PHASE_VISIBILITY:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [
              {
                id: uuidv4(),
                permissionTitle: 'permission.phase.can_set_visibility.private',
                permissionSubTitle:
                  'permission.phase.can_set_visibility.private.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.phase.can_set_visibility.shared',
                permissionSubTitle:
                  'permission.phase.can_set_visibility.shared.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.phase.can_set_visibility.both',
                permissionSubTitle:
                  'permission.phase.can_set_visibility.both.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE', 'SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.phase.edit.can_edit_phase',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PHASE:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            isDependentOn: [3],
            children: [
              {
                id: uuidv4(),
                permissionTitle: 'permission.phase.edit.can_edit_phase_name',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PHASE_NAME:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.phase.edit.can_edit_phase_dates',
                permissionSubTitle:
                  'permission.phase.edit.can_edit_phase_dates.subtitle',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PHASE_DATE:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.phase.delete.can_delete_phases',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PHASE:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            dependentField: 2,
            children: [],
          },
        ],
      },
    ],
  },
  // Tasks
  {
    sectionHeaderName: 'tasks',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.can_view',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TASK:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isDependentOn: [1, 2, 3],
            isSelected: true,
            children: [
              // {
              //   id: uuidv4(),
              //   permissionTitle: 'permission.tasks.can_view.all_tasks',
              //   permissionSubTitle:
              //     'permission.tasks.can_view.all_tasks_subtitle',
              //   type: 'radio',
              //   permissions: [
              //     {
              //       permissionName: '',
              //       requestScope: 'GLOBAL',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'GLOBAL',
              //   permissionLevel: 'PROJECT',
              //   isSelected: true,
              // },
              // {
              //   id: uuidv4(),
              //   permissionTitle: 'permission.tasks.can_view.assigned_tasks',
              //   permissionSubTitle:
              //     'permission.tasks.can_view.assigned_tasks_subtitle',
              //   type: 'radio',
              //   permissions: [
              //     {
              //       permissionName: '',
              //       requestScope: 'GLOBAL',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'GLOBAL',
              //   permissionLevel: 'PROJECT',
              //   isSelected: false,
              // },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.can_create',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TASK:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            dependentField: 0,
            children: [
              // {
              //   id: uuidv4(),
              //   permissionTitle: 'permission.tasks.can_create.in_phase',
              //   permissionSubTitle: '',
              //   type: 'checkbox',
              //   permissions: [
              //     {
              //       permissionName: 'PHASE_TASK:CREATE',
              //       requestScope: 'GLOBAL',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'GLOBAL',
              //   permissionLevel: 'PROJECT',
              //   isSelected: true,
              // },
              // {
              //   id: uuidv4(),
              //   permissionTitle: 'permission.tasks.can_add_assignee',
              //   permissionSubTitle: '',
              //   type: 'checkbox',
              //   permissions: [
              //     {
              //       permissionName: 'TASK_ASSIGNEE:WRITE',
              //       requestScope: 'GLOBAL',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'GLOBAL',
              //   permissionLevel: 'PROJECT',
              //   isSelected: true,
              // },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_set_visibility',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_VISIBILITY:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
                children: [
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.tasks.can_set_visibility.private',
                    permissionSubTitle: '',
                    type: 'radio',
                    permissions: [
                      {
                        permissionName: '',
                        requestScope: 'GLOBAL',
                        actionScopes: ['PRIVATE'],
                      },
                    ],
                    requestScope: 'GLOBAL',
                    permissionLevel: 'PROJECT',
                    isSelected: false,
                  },
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.tasks.can_set_visibility.shared',
                    permissionSubTitle: '',
                    type: 'radio',
                    permissions: [
                      {
                        permissionName: '',
                        requestScope: 'GLOBAL',
                        actionScopes: ['SHARED'],
                      },
                    ],
                    requestScope: 'GLOBAL',
                    permissionLevel: 'PROJECT',
                    isSelected: false,
                  },
                  {
                    id: uuidv4(),
                    permissionTitle: 'permission.tasks.can_set_visibility.both',
                    permissionSubTitle: '',
                    type: 'radio',
                    permissions: [
                      {
                        permissionName: '',
                        requestScope: 'GLOBAL',
                        actionScopes: ['PRIVATE', 'SHARED'],
                      },
                    ],
                    requestScope: 'GLOBAL',
                    permissionLevel: 'PROJECT',
                    isSelected: true,
                  },
                ],
              },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.can_edit',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TASK:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            dependentField: 0,
            isSelected: true,
            children: [
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.assignee',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_ASSIGNEE:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.status',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_STATUS:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.start_and_due_date',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_DATES:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.tasks.can_edit.name_and_description',
                permissionSubTitle: '',
                type: 'checkbox',
                takeActionScopeFromParent: true,
                permissions: [
                  {
                    permissionName: 'TASK_DESCRIPTION:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE'],
                  },
                  // {
                  //   permissionName: 'TASK_NAME:WRITE',
                  //   requestScope: 'GLOBAL',
                  //   actionScopes: [],
                  // },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.completed_on_date',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_COMPLETED_AT:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.started_on_date',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_ACTUAL_START:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.effort',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_EFFORT:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.progress',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_PROGRESS:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.priority',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_PRIORITY:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.tasks.can_edit.convert_to_milestone',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_TYPE:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.mark_as_at_risk',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_AT_RISK:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.mark_as_private',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_PRIVACY:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.move_across_phases',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_UPDATE_PHASE:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.request_approval',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_REQUEST_APPROVAL:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.attachments',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_ATTACHMENT:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.tasks.can_edit.create_subtasks',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'SUBTASK:CREATE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.tasks.can_edit.create_dependencies',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TASK_DEPENDENCY:WRITE',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.can_delete',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TASK:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            dependentField: 0,
            children: [],
          },
        ],
      },
    ],
  },
  // Spaces
  {
    sectionHeaderName: 'projects.spaces',
    headerName: '',
    isAllSubSectionsDependsOnViewPermission: true,
    subSections: [
      {
        sectionHeaderName: 'permission.spaces.view',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.spaces.view.can_view_documents',
            permissionSubTitle: 'permission.spaces.can_view_documents_subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'DOCUMENT:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            isMandatory: true,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: 'permission.spaces.edit',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.spaces.edit_can_edit_documents',
            permissionSubTitle:
              'permission.spaces.edit_can_edit_documents_subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'DOCUMENT:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SPACE_TAB:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.spaces.edit_can_edit_embedded_document_url',
            permissionSubTitle:
              'permission.spaces.edit_can_edit_embedded_document_url_subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SPACE_URL:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.spaces.edit_can_rearrange_documents',
            permissionSubTitle:
              'permission.spaces.edit_can_rearrange_documents_subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'DOCUMENT_REARRANGE:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: 'create',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.spaces.can_create',
            permissionSubTitle: 'permission.spaces.can_create.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SPACE:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [
              {
                id: uuidv4(),
                permissionTitle: 'permission.spaces.can_create.private',
                permissionSubTitle:
                  'permission.spaces.can_create.private.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.spaces.can_create.both',
                permissionSubTitle:
                  'permission.spaces.can_create.both.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE', 'SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
              },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.spaces.can_create_document',
            permissionSubTitle:
              'permission.spaces.can_create_document.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'DOCUMENT:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SPACE_TAB:CREATE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.spaces.can_create_document.private',
                permissionSubTitle:
                  'permission.spaces.can_create_document.private.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.spaces.can_create_document.private.both',
                permissionSubTitle:
                  'permission.spaces.can_create_document.private.both.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE', 'SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
              },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.spaces.can_embed_document_url',
            permissionSubTitle:
              'permission.spaces.can_embed_document_url.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SPACE_URL:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: 'delete',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.spaces.can_delete_space',
            permissionSubTitle: 'permission.spaces.can_delete_space.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SPACE:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.spaces.can_delete_document',
            permissionSubTitle:
              'permission.spaces.can_delete_document.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'DOCUMENT:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SPACE_TAB:DELETE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            children: [],
          },
        ],
      },
    ],
  },
  // Chat
  {
    sectionHeaderName: 'projects.tabs.chat',
    headerName: '',
    isAllSubSectionsDependsOnViewPermission: true,
    subSections: [
      {
        sectionHeaderName: 'permission.spaces.view',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.chat.can_view_conversations',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'CONVERSATION:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'COMMENT:READ',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            isMandatory: true,
            shouldDisable: false,
            // takeRequestScopeFromChild: true,
            children: [
              // {
              //   id: uuidv4(),
              //   permissionTitle: 'permission.chat.can_view_all_conversations',
              //   permissionSubTitle:
              //     'permission.chat.can_view_all_conversations.subtitle',
              //   type: 'radio',
              //   permissions: [
              //     {
              //       permissionName: '',
              //       requestScope: 'GLOBAL',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'GLOBAL',
              //   isSelected: true,
              //   permissionLevel: 'PROJECT',
              // },
              // {
              //   id: uuidv4(),
              //   permissionTitle:
              //     'permission.chat.can_view_associated_conversation',
              //   permissionSubTitle:
              //     'permission.chat.can_view_associated_conversation.subtitle',
              //   type: 'radio',
              //   permissions: [
              //     {
              //       permissionName: '',
              //       requestScope: 'RESTRICTED',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'RESTRICTED',
              //   permissionLevel: 'PROJECT',
              //   isSelected: false,
              // },
            ],
          },
        ],
      },
      {
        sectionHeaderName: 'permission.spaces.edit',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.chat.can_send_messages',
            permissionSubTitle: 'permission.chat.can_send_messages.subtitle',
            type: 'checkbox',
            permissions: [
              {
                // permissionName: 'COMMENT:CREATE',
                permissionName: 'CONVERSATION_COMMENT:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'COMMENT:DELETE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
              // {
              //   permissionName: 'COMMENT:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.chat.can_invite_members',
            permissionSubTitle: 'permission.chat.can_invite_members.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'CONVERSATION_ADD_MEMBER:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.chat.can_edit_name_and_description',
            permissionSubTitle:
              'permission.chat.can_edit_name_and_description.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'CONVERSATION:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: 'create',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.chat.can_create_project_conversation',
            permissionSubTitle:
              'permission.chat.can_create_project_conversation.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'CONVERSATION:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.chat.can_create_private_conversation',
                permissionSubTitle: '',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.chat.can_create_both_conversation',
                permissionSubTitle: '',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE', 'SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
              },
            ],
          },
          // {
          //   id: uuidv4(),
          //   permissionTitle: 'permission.chat.can_embed_url',
          //   permissionSubTitle: 'permission.chat.can_embed_url.subtitle',
          //   type: 'checkbox',
          //   permissions: [
          //     {
          //       permissionName: 'CONVERSATION_URL:CREATE',
          //       requestScope: 'GLOBAL',
          //       actionScopes: [],
          //     },
          //   ],
          //   requestScope: 'GLOBAL',
          //   permissionLevel: 'PROJECT',
          //   shouldDisable: false,
          //   isSelected: true,
          // },
        ],
      },
      {
        sectionHeaderName: 'delete',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.chat.can_delete_conversation',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'CONVERSATION:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
        ],
      },
    ],
  },
  // Start of folders
  {
    sectionHeaderName: 'permission.folders',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.folders.can_view_files_and_folders',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'FOLDER:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            isDependentOn: [1],
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.folders.can_create_folders_and_upload_files',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'FOLDER:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'FOLDER:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
              // {
              //   permissionName: 'FOLDER:DELETE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
              // {
              //   permissionName: 'ATTACHMENT:CREATE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            dependentField: 0,
            children: [
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.folders.can_create_folders_and_upload_files.private',
                permissionSubTitle: '',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.folders.can_create_folders_and_upload_files.shared',
                permissionSubTitle: '',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.folders.can_create_folders_and_upload_files.both',
                permissionSubTitle: '',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE', 'SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
              },
            ],
          },
        ],
      },
    ],
  },
  // start of project updates
  {
    sectionHeaderName: 'permission.project_updates',
    headerName: null,
    subSections: [
      {
        sectionHeaderName: '',
        headerName: '',
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.project_updates.can_view_updates',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'STATUS_UPDATE:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            isDependentOn: [1],
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.project_updates.can_create_and_publish_updates',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'STATUS_UPDATE:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'STATUS_UPDATE:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
              // {
              //   permissionName: 'STATUS_UPDATE_PUBLISH:CREATE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            dependentField: 0,
            children: [
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.project_updates.can_create_and_publish_updates.private',
                permissionSubTitle: '',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.project_updates.can_create_and_publish_updates.shared',
                permissionSubTitle: '',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: false,
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.project_updates.can_create_and_publish_updates.both',
                permissionSubTitle: '',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['PRIVATE', 'SHARED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
  // Start of templates
  {
    sectionHeaderName: 'permission.templates',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.templates.can_create_and_manage_templates',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TEMPLATE:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'TEMPLATE:CREATE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
              // {
              //   permissionName: 'TEMPLATE_PAGE:READ',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
        ],
      },
    ],
  },
  // Start of dashboard permission set
  {
    sectionHeaderName: 'permission.dashboard',
    headerName: '',
    isAllSubSectionsDependsOnViewPermission: true,
    subSections: [
      {
        sectionHeaderName: 'permission.spaces.view',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.dashboard.can_view_dashboards',
            permissionSubTitle:
              'permission.dashboard.can_view_dashboards.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'DASHBOARD:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            isMandatory: true,
            shouldDisable: false,
            children: [],
            // scopeModalOptions: {
            //   modalTitle: 'settings.permission.menu.title',
            //   fields: [
            //     {
            //       id: uuidv4(),
            //       permissionTitle:
            //         'permission.dashboard.can_view_dashboards.global_access',
            //       permissionSubTitle:
            //         'permission.dashboard.can_view_dashboards.global_access.subtitle',
            //       type: 'radio',
            //       requestScope: 'GLOBAL',
            //       isSelected: true,
            //     },
            //     {
            //       id: uuidv4(),
            //       permissionTitle:
            //         'permission.dashboard.can_view_dashboards.group',
            //       permissionSubTitle:
            //         'permission.dashboard.can_view_dashboards.group.subtitle',
            //       type: 'radio',
            //       requestScope: 'GROUP',
            //       isSelected: false,
            //     },
            //   ],
            // },
          },
        ],
      },
      {
        sectionHeaderName: 'create',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.dashboard.can_manage_dashboards_and_widgets',
            permissionSubTitle:
              'permission.dashboard.can_manage_dashboards_and_widgets.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'DASHBOARD:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          // {
          //   id: uuidv4(),
          //   permissionTitle: 'permission.dashboard.can_share_dashboards',
          //   permissionSubTitle:
          //     'permission.dashboard.can_share_dashboards.subtitle',
          //   type: 'checkbox',
          //   permissions: [
          //     {
          //       permissionName: 'DASHBOARD_SHARE:CREATE',
          //       requestScope: 'GLOBAL',
          //       actionScopes: [],
          //     },
          //   ],
          //   requestScope: 'GLOBAL',
          //   permissionLevel: 'ACCOUNT',
          //   isSelected: true,
          //   shouldDisable: false,
          //   scopeModalOptions: {
          //     modalTitle: 'settings.permission.menu.title',
          //     fields: [
          //       {
          //         id: uuidv4(),
          //         permissionTitle:
          //           'permission.dashboard.can_share_dashboards.global_access',
          //         permissionSubTitle:
          //           'permission.dashboard.can_share_dashboards.global_access.subtitle',
          //         type: 'radio',
          //         requestScope: 'GLOBAL',
          //         isSelected: true,
          //       },
          //       {
          //         id: uuidv4(),
          //         permissionTitle:
          //           'permission.dashboard.can_share_dashboards.group',
          //         permissionSubTitle:
          //           'permission.dashboard.can_share_dashboards.group.subtitle',
          //         type: 'radio',
          //         requestScope: 'GROUP',
          //         isSelected: false,
          //       },
          //     ],
          //   },
          //   children: [],
          // },
        ],
      },
    ],
  },
  // Start of Reports
  {
    sectionHeaderName: 'permission.reports',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.reports.can_view',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'REPORT:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [
              {
                id: uuidv4(),
                permissionTitle: 'permission.reports.can_view_csat',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'CSAT_REPORT:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: true,
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.reports.can_view_time_tracking',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'TIME_TRACKING_REPORT:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: true,
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.reports.can_view_project_performance',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PROJECT_PERFORMANCE_REPORT:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: true,
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.reports.can_view_people_performance',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PEOPLE_PERFORMANCE_REPORT:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: true,
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.reports.can_view_operations_insight',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'OPERATIONS_INSIGHT_REPORT:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: true,
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.reports.can_view_interval_iq',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'INTERVAL_IQ:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: true,
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle: 'permission.reports.can_view_portfolio',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PORTFOLIO_REPORT:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: true,
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
  // Start of key events and intervals permission set
  {
    sectionHeaderName: 'permission.key_events_and_intervals',
    headerName: '',
    isAllSubSectionsDependsOnViewPermission: false,
    subSections: [
      {
        sectionHeaderName: 'permission.key_events_and_intervals.settings',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.key_events_and_intervals.settings.can_create_new_key_event',
            permissionSubTitle:
              'permission.key_events_and_intervals.settings.can_create_new_key_event.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'KEY_EVENT:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.key_events_and_intervals.settings.can_edit_key_event',
            permissionSubTitle:
              'permission.key_events_and_intervals.settings.can_edit_key_event.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'KEY_EVENT:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.key_events_and_intervals.settings.can_delete_key_event',
            permissionSubTitle:
              'permission.key_events_and_intervals.settings.can_delete_key_event.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'KEY_EVENT:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: 'permission.key_events_and_intervals.field_values',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.key_events_and_intervals.field_values.can_view_key_events_field_values',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'KEY_EVENT_VALUE:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            isDependentOn: [1],
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.key_events_and_intervals.field_values.can_manage_key_events_field_values',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'KEY_EVENT_VALUE:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            dependentField: 0,
            children: [],
          },
        ],
      },
    ],
  },
  // Start of settings permission set
  {
    sectionHeaderName: 'permission.settings',
    headerName: '',
    isAllSubSectionsDependsOnViewPermission: false,
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.settings.can_manage_account_preferences',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_ORGANISATION:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_holiday_calendars',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_HOLIDAY_CALENDAR:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_plans_and_biling',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'BILLING:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'BILLING:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
              // {
              //   permissionName: 'BILLING:CREATE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
              // {
              //   permissionName: 'BILLING:DELETE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_team_members',
            permissionSubTitle:
              'permission.settings.can_manage_team_member_fields.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TEAM_MEMBER:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_roles',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_ROLE:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SETTINGS_ROLE:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.settings.can_manage_customer_portal_configuration',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_CUSTOMER_PORTAL:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SETTINGS_CUSTOMER_PORTAL:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_partner_companies',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_PARTNER:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SETTINGS_PARTNER:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_integrations',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_INTEGRATION:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SETTINGS_INTEGRATION:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.settings.can_manage_time_tracking_settings',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TIME_SHEET:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SETTINGS_TIME_SHEET:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_rm_settings',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_RESOURCE_MANAGEMENT:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SETTINGS_RESOURCE_MANAGEMENT:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.settings.can_manage_financial_management_settings',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_FINANCIAL:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SETTINGS_FINANCIAL:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_currencies',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_CURRENCY:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_advanced_settings',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_ADVANCED:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_kei',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_KEY_EVENTS_AND_INTERVALS:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'SETTINGS_KEY_EVENTS_AND_INTERVALS:WRITE',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.settings.can_manage_automations',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_AUTOMATION:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
        ],
      },
    ],
  },
  // Project Fields
  {
    sectionHeaderName: 'project_fields',
    headerName: null,
    subSections: [
      {
        sectionHeaderName: '',
        headerName: '',
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.projects.project_fields.can_manage_project_fields',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_PROJECT_FIELD:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            isMandatory: true,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: '',
        headerName: 'permission.project.fields.settings',
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.project.fields.can_create_new_fields',
            permissionSubTitle:
              'permission.project.fields.can_create_new_fields.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_PROJECT_FIELD:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.project.fields.can_edit_existing_fields',
            permissionSubTitle:
              'permission.project.fields.can_edit_existing_fields_subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_PROJECT_FIELD:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.project.fields.can_create_new_fields_section',
            permissionSubTitle:
              'permission.project.fields.can_create_new_fields_section.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT_FIELD_SECTION:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.project.fields.can_associate_field_sections_to_groups',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT_GROUP_FIELD_SECTION:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.project.fields.can_associate_field_sections_to_groups.all_groups',
                permissionSubTitle:
                  'permission.project.fields.can_associate_field_sections_to_groups.all_groups.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['ALL_GROUPS'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: true,
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.project.fields.can_associate_field_sections_to_groups.restricted',
                permissionSubTitle:
                  'permission.project.fields.can_associate_field_sections_to_groups.restricted.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['RESTRICTED'],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'ACCOUNT',
                isSelected: false,
              },
            ],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.project.fields.can_delete_fields',
            permissionSubTitle:
              'permission.project.fields.can_delete_fields.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_PROJECT_FIELD:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: '',
        headerName: 'permission.project.fields.values',
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.project.fields.values.can_view',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT_FIELD:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
              // {
              //   permissionName: 'PROJECT_INFO_SECTION:READ',
              //   requestScope: 'GLOBAL',
              //   actionScopes: [],
              // },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            isDependentOn: [1],
            scopeModalOptions: [
              {
                id: uuidv4(),
                modalTitle: 'settings.permission.menu.title',
                fields: [
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.project.fields.values.can_view.global_access',
                    permissionSubTitle:
                      'permission.project.fields.values.can_view.global_access.subtitle',
                    type: 'radio',
                    requestScope: 'GLOBAL',
                    isSelected: true,
                  },
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.project.fields.values.can_view.group',
                    permissionSubTitle:
                      'permission.project.fields.values.can_view.group.subtitle',
                    type: 'radio',
                    requestScope: 'GROUP',
                    isSelected: false,
                  },
                ],
              },
            ],
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.project.fields.values.can_edit',
            permissionSubTitle:
              'permission.project.fields.values.can_edit_subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT_FIELD:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            dependentField: 0,
            scopeModalOptions: [
              {
                id: uuidv4(),
                modalTitle: 'settings.permission.menu.title',
                fields: [
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.project.fields.values.can_edit.global_access',
                    permissionSubTitle:
                      'permission.project.fields.values.can_edit.global_access.subtitle',
                    type: 'radio',
                    requestScope: 'GLOBAL',
                    isSelected: true,
                  },
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.project.fields.values.can_edit.group',
                    permissionSubTitle:
                      'permission.project.fields.values.can_edit.group.subtitle',
                    type: 'radio',
                    requestScope: 'GROUP',
                    isSelected: false,
                  },
                ],
              },
            ],
            children: [],
          },
        ],
        notDependentOnAnyAboveSections: true,
      },
    ],
  },

  // Task Fields
  {
    sectionHeaderName: 'task_fields',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.projects.project_fields.can_manage_task_fields',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TASK_FIELD:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            isMandatory: true,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: 'permission.tasks.fields.settings',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.fields.can_create_new_fields',
            permissionSubTitle:
              'permission.tasks.fields.can_create_new_fields.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TASK_FIELD:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.fields.can_edit_existing_fields',
            permissionSubTitle:
              'permission.tasks.fields.can_edit_existing_fields_subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TASK_FIELD:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.fields.can_delete_fields',
            permissionSubTitle:
              'permission.tasks.fields.can_delete_fields.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TASK_FIELD:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.tasks.fields.can_create_new_fields_section',
            permissionSubTitle:
              'permission.tasks.fields.can_create_new_fields_section.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TASK_FIELD_SECTION:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.tasks.fields.can_associate_field_sections_to_groups',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TASK_GROUP_FIELD_SECTION:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.tasks.fields.can_associate_field_sections_to_groups.all_groups',
                permissionSubTitle:
                  'permission.tasks.fields.can_associate_field_sections_to_groups.all_groups.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['ALL_GROUPS'],
                  },
                ],
                requestScope: 'GLOBAL',
                isSelected: true,
                permissionLevel: 'ACCOUNT',
                children: [],
              },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.tasks.fields.can_associate_field_sections_to_groups.restricted',
                permissionSubTitle:
                  'permission.tasks.fields.can_associate_field_sections_to_groups.restricted.subtitle',
                type: 'radio',
                permissions: [
                  {
                    permissionName: '',
                    requestScope: 'GLOBAL',
                    actionScopes: ['RESTRICTED'],
                  },
                ],
                requestScope: 'GLOBAL',
                isSelected: false,
                permissionLevel: 'ACCOUNT',
                children: [],
              },
            ],
          },
        ],
      },
      {
        sectionHeaderName: 'permission.tasks.fields.values',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.fields.values.can_view',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TASK_FIELD:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            isDependentOn: [1],
            scopeModalOptions: [
              {
                id: uuidv4(),
                modalTitle: 'settings.permission.menu.title',
                fields: [
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.tasks.fields.values.can_view.global_access',
                    permissionSubTitle:
                      'permission.tasks.fields.values.can_view.global_access.subtitle',
                    type: 'radio',
                    requestScope: 'GLOBAL',
                    isSelected: true,
                  },
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.tasks.fields.values.can_view.group',
                    permissionSubTitle:
                      'permission.tasks.fields.values.can_view.group.subtitle',
                    type: 'radio',
                    requestScope: 'GROUP',
                    isSelected: false,
                  },
                ],
              },
            ],
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.tasks.fields.values.can_edit',
            permissionSubTitle:
              'permission.tasks.fields.values.can_edit_subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TASK_FIELD:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            dependentField: 0,
            scopeModalOptions: [
              {
                id: uuidv4(),
                modalTitle: 'settings.permission.menu.title',
                fields: [
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.tasks.fields.values.can_edit.global_access',
                    permissionSubTitle:
                      'permission.tasks.fields.values.can_edit.global_access.subtitle',
                    type: 'radio',
                    requestScope: 'GLOBAL',
                    isSelected: true,
                  },
                  {
                    id: uuidv4(),
                    permissionTitle:
                      'permission.tasks.fields.values.can_edit.group',
                    permissionSubTitle:
                      'permission.tasks.fields.values.can_edit.group.subtitle',
                    type: 'radio',
                    requestScope: 'GROUP',
                    isSelected: false,
                  },
                ],
              },
            ],
            children: [],
          },
        ],
        notDependentOnAnyAboveSections: true,
      },
    ],
  },
  // Team member Fields
  {
    sectionHeaderName: 'permission.team_member_fields',
    headerName: null,
    subSections: [
      {
        sectionHeaderName: '',
        headerName: '',
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.settings.can_manage_team_member_fields',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TEAM_MEMBER_FIELD:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            isMandatory: true,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: '',
        headerName: 'permission.team_member_fields_settings.title',
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.team_member_fields.fields.can_create_new_fields',
            permissionSubTitle:
              'permission.team_member_fields.fields.can_create_new_fields',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TEAM_MEMBER_FIELD:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.team_member_fields.fields.can_edit_existing_fields',
            permissionSubTitle:
              'permission.team_member_fields.fields.can_edit_existing_fields.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TEAM_MEMBER_FIELD:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.team_member_fields.fields.can_manage_fields_section',
            permissionSubTitle:
              'permission.team_member_fields.fields.can_manage_fields_section.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TEAM_MEMBER_FIELD_SECTION:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.team_member_fields.fields.can_delete_fields',
            permissionSubTitle:
              'permission.team_member_fields.fields.can_delete_fields.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'SETTINGS_TEAM_MEMBER_FIELD:DELETE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
        ],
      },
    ],
  },

  // Start of timesheets
  {
    sectionHeaderName: 'permission.timesheets',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.timesheets.can_view_timesheets',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'TIMESHEET:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
        ],
      },
      // {
      //   sectionHeaderName: '',
      //   headerName: null,
      //   fields: [
      //     {
      //       id: uuidv4(),
      //       permissionTitle:
      //         'permission.timesheets.can_manage_time_tracking_settings',
      //       permissionSubTitle: '',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: 'TIMESHEET:READ',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: true,
      //       children: [],
      //     },
      //   ],
      // },
      // {
      //   sectionHeaderName: 'permission.timesheets',
      //   headerName: null,
      //   fields: [
      //     {
      //       id: uuidv4(),
      //       permissionTitle:
      //         'permission.timesheets.can_create_and_edit_time_entries',
      //       permissionSubTitle: '',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: 'TIMESHEET:READ',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: false,
      //       scopeModalOptions: {
      //         modalTitle: 'settings.permission.menu.title',
      //         fields: [
      //           {
      //             id: uuidv4(),
      //             permissionTitle:
      //               'permission.view.can.view_projects.global_access',
      //             permissionSubTitle:
      //               'permission.timesheet.project_access.global',
      //             type: 'radio',
      //             requestScope: 'GLOBAL',
      //             isSelected: true,
      //           },
      //           {
      //             id: uuidv4(),
      //             permissionTitle: 'permission.view.can.view_projects.group',
      //             permissionSubTitle:
      //               'permission.timesheet.project_access.group',
      //             type: 'radio',
      //             requestScope: 'GROUP',
      //             isSelected: false,
      //           },
      //           {
      //             id: uuidv4(),
      //             permissionTitle:
      //               'permission.view.can.view_projects.participant_and_all',
      //             permissionSubTitle:
      //               'permission.timesheet.project_access.participant_and_all',
      //             type: 'radio',
      //             requestScope: 'LESS_RESTRICTED',
      //             isSelected: false,
      //           },
      //         ],
      //       },
      //       children: [],
      //     },
      //     {
      //       id: uuidv4(),
      //       permissionTitle:
      //         'permission.timesheets.can_withdraw_their_approved_time_entries',
      //       permissionSubTitle: '',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: 'TIMESHEET:READ',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: false,
      //       children: [],
      //     },
      //   ],
      // },
      // {
      //   sectionHeaderName: 'permission.approvals',
      //   headerName: null,
      //   fields: [],
      // },
      // {
      //   sectionHeaderName: 'permission.approvals.for_projects',
      //   headerName: null,
      //   fields: [
      //     {
      //       id: uuidv4(),
      //       permissionTitle: 'permission.approvals.can_approve_timesheets',
      //       permissionSubTitle:
      //         'permission.approvals.can_approve_timesheets.description',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: 'TIMESHEET:READ',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: false,
      //       children: [
      //         {
      //           id: uuidv4(),
      //           permissionTitle:
      //             'permission.approvals.can_add_or_change_time_entries_while_approving',
      //           permissionSubTitle: '',
      //           type: 'checkbox',
      //           permissions: [
      //             {
      //               permissionName: 'TIMESHEET:READ',
      //               requestScope: 'GLOBAL',
      //               actionScopes: [],
      //             },
      //           ],
      //           requestScope: 'GLOBAL',
      //           permissionLevel: 'ACCOUNT',
      //           isSelected: false,
      //         },
      //         {
      //           id: uuidv4(),
      //           permissionTitle:
      //             'permission.approvals.can_approve_their_own_timesheets',
      //           permissionSubTitle: '',
      //           type: 'checkbox',
      //           permissions: [
      //             {
      //               permissionName: 'TIMESHEET:READ',
      //               requestScope: 'GLOBAL',
      //               actionScopes: [],
      //             },
      //           ],
      //           requestScope: 'GLOBAL',
      //           permissionLevel: 'ACCOUNT',
      //           isSelected: false,
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   sectionHeaderName: 'permission.approvals.for_non_project_activities',
      //   headerName: null,
      //   fields: [
      //     {
      //       id: uuidv4(),
      //       permissionTitle: 'permission.approvals.can_approve_timesheets',
      //       permissionSubTitle:
      //         'permission.approvals.can_approve_timesheets.description',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: 'TIMESHEET:READ',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: false,
      //       children: [
      //         {
      //           id: uuidv4(),
      //           permissionTitle:
      //             'permission.approvals.can_add_or_change_time_entries_while_approving',
      //           permissionSubTitle: '',
      //           type: 'checkbox',
      //           permissions: [
      //             {
      //               permissionName: 'TIMESHEET:READ',
      //               requestScope: 'GLOBAL',
      //               actionScopes: [],
      //             },
      //           ],
      //           requestScope: 'GLOBAL',
      //           permissionLevel: 'ACCOUNT',
      //           isSelected: false,
      //         },
      //         {
      //           id: uuidv4(),
      //           permissionTitle:
      //             'permission.approvals.can_approve_their_own_timesheets',
      //           permissionSubTitle: '',
      //           type: 'checkbox',
      //           permissions: [
      //             {
      //               permissionName: 'TIMESHEET:READ',
      //               requestScope: 'GLOBAL',
      //               actionScopes: [],
      //             },
      //           ],
      //           requestScope: 'GLOBAL',
      //           permissionLevel: 'ACCOUNT',
      //           isSelected: false,
      //         },
      //       ],
      //     },
      //   ],
      // },
    ],
  },
  // Start of rm
  {
    sectionHeaderName: 'permission.rm',
    headerName: '',
    subSections: [
      {
        sectionHeaderName: '',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.rm.can_view_rm',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'RESOURCE_MANAGEMENT:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            children: [],
          },
        ],
      },
      // {
      //   sectionHeaderName: '',
      //   headerName: null,
      //   fields: [
      //     {
      //       id: uuidv4(),
      //       permissionTitle: 'permission.rm.can_manage_rm',
      //       permissionSubTitle: '',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: '',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: true,
      //       children: [],
      //     },
      //     {
      //       id: uuidv4(),
      //       permissionTitle: 'permission.rm.can_view_allocations',
      //       permissionSubTitle: 'permission.rm.can_view_allocations.subtitle',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: '',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: true,
      //       children: [],
      //     },
      //     {
      //       id: uuidv4(),
      //       permissionTitle: 'permission.rm.can_create_allocations',
      //       permissionSubTitle: 'permission.rm.can_create_allocations.subtitle',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: '',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: true,
      //       children: [
      //         {
      //           id: uuidv4(),
      //           permissionTitle: 'permission.rm.can_create_hard_allocations',
      //           permissionSubTitle: '',
      //           type: 'checkbox',
      //           permissions: [
      //             {
      //               permissionName: '',
      //               requestScope: 'GLOBAL',
      //               actionScopes: [],
      //             },
      //           ],
      //           requestScope: 'GLOBAL',
      //           permissionLevel: 'ACCOUNT',
      //           isSelected: true,
      //         },
      //       ],
      //     },
      //     {
      //       id: uuidv4(),
      //       permissionTitle: 'permission.rm.can_update_allocations',
      //       permissionSubTitle: 'permission.rm.can_update_allocations.subtitle',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: '',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: true,
      //       children: [
      //         {
      //           id: uuidv4(),
      //           permissionTitle:
      //             'permission.rm.can_convert_soft_to_hard_allocations',
      //           permissionSubTitle: '',
      //           type: 'checkbox',
      //           permissions: [
      //             {
      //               permissionName: '',
      //               requestScope: 'GLOBAL',
      //               actionScopes: [],
      //             },
      //           ],
      //           requestScope: 'GLOBAL',
      //           permissionLevel: 'ACCOUNT',
      //           isSelected: true,
      //         },
      //       ],
      //     },
      //     {
      //       id: uuidv4(),
      //       permissionTitle: 'permission.rm.can_delete_soft_allocations',
      //       permissionSubTitle: '',
      //       type: 'checkbox',
      //       permissions: [
      //         {
      //           permissionName: '',
      //           requestScope: 'GLOBAL',
      //           actionScopes: [],
      //         },
      //       ],
      //       requestScope: 'GLOBAL',
      //       permissionLevel: 'ACCOUNT',
      //       isSelected: true,
      //       children: [],
      //     },
      //   ],
      // },
    ],
  },
  // Start of financials permission set
  {
    sectionHeaderName: 'permission.financials',
    headerName: '',
    isAllSubSectionsDependsOnViewPermission: false,
    subSections: [
      {
        sectionHeaderName: 'permission.spaces.view',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle: 'permission.financials.view.can_view_rate_cards',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'RATE_CARD:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            isMaster: true,
            slaves: [
              {
                sectionIndex: 17,
                subSectionIndex: 1,
                fieldIndex: [0],
                childIndex: [],
                performOnChild: false,
              },
            ],
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle: 'permission.financials.view.can_view_cost_rates',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'COST_RATE:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: 'create',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.financials.create.can_create_and_manage_rate_cards',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'RATE_CARD:CREATE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
        ],
      },
      {
        sectionHeaderName: 'permission.spaces.edit',
        headerName: null,
        fields: [
          //* Not needed
          // {
          //   id: uuidv4(),
          //   permissionTitle: 'permission.financials.edit.can_manage_rate_cards',
          //   permissionSubTitle: '',
          //   type: 'checkbox',
          //   permissions: [
          //     {
          //       permissionName: 'RATE_CARD:WRITE',
          //       requestScope: 'GLOBAL',
          //       actionScopes: [],
          //     },
          //   ],
          //   requestScope: 'GLOBAL',
          //   permissionLevel: 'ACCOUNT',
          //   isSelected: true,
          //   shouldDisable: false,
          //   children: [],
          // },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.financials.edit.can_manage_cost_rates_for_roles_and_team_members',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'COST_RATE:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          // {
          //   id: uuidv4(),
          //   permissionTitle:
          //     'permission.financials.edit.can_manage_cost_rates_for_team_members',
          //   permissionSubTitle: '',
          //   type: 'checkbox',
          //   permissions: [
          //     {
          //       permissionName: 'COST_RATE:WRITE',
          //       requestScope: 'GLOBAL',
          //       actionScopes: [],
          //     },
          //   ],
          //   requestScope: 'GLOBAL',
          //   permissionLevel: 'ACCOUNT',
          //   isSelected: true,
          //   shouldDisable: false,
          //   scopeModalOptions: {
          //     modalTitle: 'settings.permission.menu.title',
          //     fields: [
          //       {
          //         id: uuidv4(),
          //         permissionTitle:
          //           'permission.financials.edit.can_manage_cost_rates_for_team_members.global_access',
          //         permissionSubTitle:
          //           'permission.financials.edit.can_manage_cost_rates_for_team_members.global_access.subtitle',
          //         type: 'radio',
          //         requestScope: 'GLOBAL',
          //         isSelected: true,
          //       },
          //       {
          //         id: uuidv4(),
          //         permissionTitle:
          //           'permission.financials.edit.can_manage_cost_rates_for_team_members.group',
          //         permissionSubTitle:
          //           'permission.financials.edit.can_manage_cost_rates_for_team_members.group.subtitle',
          //         type: 'radio',
          //         requestScope: 'GROUP',
          //         isSelected: false,
          //       },
          //       {
          //         id: uuidv4(),
          //         permissionTitle:
          //           'permission.financials.edit.can_manage_cost_rates_for_team_members.noone',
          //         permissionSubTitle:
          //           'permission.financials.edit.can_manage_cost_rates_for_team_members.noone.subtitle',
          //         type: 'radio',
          //         requestScope: 'GROUP',
          //         isSelected: false,
          //       },
          //     ],
          //   },
          //   children: [],
          // },
        ],
      },
      {
        sectionHeaderName: 'project',
        headerName: null,
        fields: [],
        removeExtraSpaces: true,
      },
      {
        sectionHeaderName: 'permission.spaces.view',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.financials.projects.view.can_view_financial_fields_and_numbers',
            permissionSubTitle:
              'permission.financials.projects.view.can_view_financial_fields_and_numbers.subtitle',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT_FINANCIALS:READ',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.financials.projects.view.can_view_financial_fields_and_numbers.budgets_billrates_revenue',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PROJECT_BUDGET:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
                shouldDisable: false,
                slaves: [
                  {
                    sectionIndex: 17, // section index of the field which you want to manipulate
                    subSectionIndex: 4, // sub-section index of the field which you want to manipulate
                    fieldIndex: [0], // field index of the field which you want to manipulate
                    childIndex: [1], // field index of the field which you want to manipulate
                    performOnChild: true,
                  },
                ],
                children: [],
              },
              // {
              //   id: uuidv4(),
              //   permissionTitle:
              //     'permission.financials.projects.view.can_view_financial_fields_and_numbers.bill_rates',
              //   permissionSubTitle: '',
              //   type: 'checkbox',
              //   permissions: [
              //     {
              //       permissionName: 'PROJECT_BILL_RATE_OVERRIDE:READ',
              //       requestScope: 'GLOBAL',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'GLOBAL',
              //   permissionLevel: 'ACCOUNT',
              //   isSelected: true,
              //   shouldDisable: false,
              //   children: [],
              // },
              // {
              //   id: uuidv4(),
              //   permissionTitle:
              //     'permission.financials.projects.view.can_view_financial_fields_and_numbers.revenue',
              //   permissionSubTitle: '',
              //   type: 'checkbox',
              //   permissions: [
              //     {
              //       permissionName: 'PROJECT_REVENUE:READ',
              //       requestScope: 'GLOBAL',
              //       actionScopes: [],
              //     },
              //   ],
              //   requestScope: 'GLOBAL',
              //   permissionLevel: 'PROJECT',
              //   isSelected: true,
              //   shouldDisable: false,
              //   children: [],
              // },
              {
                id: uuidv4(),
                permissionTitle:
                  'permission.financials.projects.view.can_view_financial_fields_and_numbers.cost_profit_and_margins',
                permissionSubTitle: '',
                type: 'checkbox',
                permissions: [
                  {
                    permissionName: 'PROJECT_PROFITABILITY:READ',
                    requestScope: 'GLOBAL',
                    actionScopes: [],
                  },
                ],
                requestScope: 'GLOBAL',
                permissionLevel: 'PROJECT',
                isSelected: true,
                shouldDisable: false,
                children: [],
              },
            ],
          },
        ],
      },
      {
        sectionHeaderName: 'permission.spaces.edit',
        headerName: null,
        fields: [
          {
            id: uuidv4(),
            permissionTitle:
              'permission.financials.projects.edit.can_change_billing_type',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'BILLING_TYPE:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.financials.projects.edit.can_change_budgets',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT_BUDGET:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.financials.projects.edit.can_change_rate_cards',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT_RATE_CARD_UPDATE:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'PROJECT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
          {
            id: uuidv4(),
            permissionTitle:
              'permission.financials.projects.edit.can_manually_override_bill_rates',
            permissionSubTitle: '',
            type: 'checkbox',
            permissions: [
              {
                permissionName: 'PROJECT_BILL_RATE_OVERRIDE:WRITE',
                requestScope: 'GLOBAL',
                actionScopes: [],
              },
            ],
            requestScope: 'GLOBAL',
            permissionLevel: 'ACCOUNT',
            isSelected: true,
            shouldDisable: false,
            children: [],
          },
        ],
      },
    ],
  },
];

export const actualDataForAccessibleNavItems = [
  {
    menuName: 'projects.title',
    menuIcon: Help16,
    route: '#projects',
  },
  {
    menuName: 'phase',
    menuIcon: Help16,
    route: '#phase',
  },
  {
    menuName: 'tasks',
    menuIcon: Help16,
    route: '#tasks',
  },
  {
    menuName: 'projects.tabs.spaces',
    menuIcon: Help16,
    route: '#spaces',
  },
  {
    menuName: 'projects.tabs.chat',
    menuIcon: Help16,
    route: '#chat',
  },
  {
    menuName: 'permission.folders',
    menuIcon: Help16,
    route: '#folders',
  },
  {
    menuName: 'permission.project_updates',
    menuIcon: Help16,
    route: '#statusUpdates',
  },
  {
    menuName: 'permission.templates',
    menuIcon: Help16,
    route: '#templates',
  },
  {
    menuName: 'permission.dashboard',
    menuIcon: Help16,
    route: '#dashboard',
  },
  {
    menuName: 'permission.reports',
    menuIcon: Help16,
    route: '#reports',
  },
  {
    menuName: 'permission.key_events_and_intervals',
    menuIcon: Help16,
    route: '#key-events-and-intervals',
  },
  {
    menuName: 'permission.settings',
    menuIcon: Help16,
    route: '#settings',
  },
  {
    menuName: 'project_fields',
    menuIcon: Help16,
    route: '#projectFields',
  },

  {
    menuName: 'task_fields',
    menuIcon: Help16,
    route: '#taskFields',
  },
  {
    menuName: 'permission.team_member_fields',
    menuIcon: Help16,
    route: '#teamMemberFields',
  },
  {
    menuName: 'permission.timesheets',
    menuIcon: Help16,
    route: '#timesheets',
  },
  {
    menuName: 'permission.rm',
    menuIcon: Help16,
    route: '#resource-management',
  },
  {
    menuName: 'permission.financials',
    menuIcon: Help16,
    route: '#financials',
  },
];

export const actualDataToRenderForProjectsLevelPermissionCreationScreen: Section[] =
  [
    // Projects
    {
      sectionHeaderName: 'projects.title',
      headerName: '',
      subSections: [
        {
          sectionHeaderName: '',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.edit.can_edit_projects',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PROJECT:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              isSelected: true,
              permissionLevel: 'PROJECT',
              // dependentField: 1,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.edit.can_add_partners',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PROJECT_PARTNER:CREATE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.edit.can_invite_team_members',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PROJECT_MEMBER:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: ['NATIVE', 'PARTNER'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                // {
                //   id: uuidv4(),
                //   permissionTitle: 'permission.edit.can_set_financials',
                //   permissionSubTitle: '',
                //   type: 'checkbox',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                // },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.edit.can_invite_customer_team_members',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PROJECT_MEMBER:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: ['EXTERNAL'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.edit.can_set_visibility',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PROJECT_VISIBILITY:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.delete.can_delete_projects',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PROJECT:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              isSelected: true,
              permissionLevel: 'PROJECT',
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'permission.projects.project_fields',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.projects.project_fields.view_project_field_values',
              permissionSubTitle:
                'permission.projects.project_fields.view_project_field_values.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PROJECT_FIELD:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              isSelected: true,
              permissionLevel: 'PROJECT',
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.project_fields.view_project_field_values.same_account_permissions',
                //   permissionSubTitle:
                //     'permission.projects.project_fields.view_project_field_values.same_account_permissions.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.project_fields.view_project_field_values.additional_field_sections',
                //   permissionSubTitle: '',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                // },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.projects.project_fields.edit_project_field_values',
              permissionSubTitle:
                'permission.projects.project_fields.edit_project_field_values.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PROJECT_FIELD:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              isSelected: true,
              permissionLevel: 'PROJECT',
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.project_fields.edit_project_field_values.same_account_permissions',
                //   permissionSubTitle:
                //     'permission.projects.project_fields.edit_project_field_values.same_account_permissions.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.project_fields.edit_project_field_values.additional_field_sections',
                //   permissionSubTitle:
                //     'permission.projects.project_fields.edit_project_field_values.additional_field_sections.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   showMultiSelect: {
                //     type: 'projectFields',
                //     selectedOptions: [],
                //   },
                //   isSelected: false,
                // },
              ],
            },
          ],
        },
        {
          sectionHeaderName: '',
          headerName: 'permission.project.team_member_permissions',
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.project.can_associate_project_permissions',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'ASSOCIATE_PROJECT_PERMISSION:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              isSelected: true,
              permissionLevel: 'PROJECT',
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.team_members.same_account_permissions',
                //   permissionSubTitle:
                //     'permission.projects.team_members.same_account_permissions.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.project.permissions.additional_project_permissions',
                //   permissionSubTitle:
                //     'permission.projects.team_members.additional_field_sections.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   showMultiSelect: {
                //     type: 'projectPermissions',
                //     selectedOptions: [],
                //   },
                //   isSelected: false,
                // },
              ],
            },
          ],
        },
      ],
    },
    // Start of phase related permissions
    {
      sectionHeaderName: 'phase',
      headerName: '',
      subSections: [
        {
          sectionHeaderName: '',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.phase.can_create_phase',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PHASE:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              permissionLevel: 'PROJECT',
              requestScope: 'GLOBAL',
              isSelected: true,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.phase.can_set_visibility',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PHASE_VISIBILITY:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.phase.can_set_visibility.private',
                  permissionSubTitle:
                    'permission.phase.can_set_visibility.private.subtitle',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.phase.can_set_visibility.shared',
                  permissionSubTitle:
                    'permission.phase.can_set_visibility.shared.subtitle',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.phase.can_set_visibility.both',
                  permissionSubTitle:
                    'permission.phase.can_set_visibility.both.subtitle',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE', 'SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.phase.edit.can_edit_phase',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PHASE:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.phase.edit.can_edit_phase_name',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PHASE_NAME:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.phase.edit.can_edit_phase_dates',
                  permissionSubTitle:
                    'permission.phase.edit.can_edit_phase_dates.subtitle',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PHASE_DATE:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
              ],
            },

            {
              id: uuidv4(),
              permissionTitle: 'permission.phase.delete.can_delete_phases',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PHASE:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
          ],
        },
      ],
    },
    // Start of tasks related permissions
    {
      sectionHeaderName: 'tasks',
      headerName: '',
      subSections: [
        {
          sectionHeaderName: '',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.tasks.can_view',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isDependentOn: [1, 2, 3],
              isSelected: true,
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle: 'permission.tasks.can_view.all_tasks',
                //   permissionSubTitle:
                //     'permission.tasks.can_view.all_tasks_subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle: 'permission.tasks.can_view.assigned_tasks',
                //   permissionSubTitle:
                //     'permission.tasks.can_view.assigned_tasks_subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                // },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.tasks.can_create',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              dependentField: 0,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_set_visibility',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_VISIBILITY:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                  children: [
                    {
                      id: uuidv4(),
                      permissionTitle:
                        'permission.tasks.can_set_visibility.private',
                      permissionSubTitle: '',
                      type: 'radio',
                      permissions: [
                        {
                          permissionName: '',
                          requestScope: 'GLOBAL',
                          actionScopes: ['PRIVATE'],
                        },
                      ],
                      requestScope: 'GLOBAL',
                      permissionLevel: 'PROJECT',
                      isSelected: false,
                    },
                    {
                      id: uuidv4(),
                      permissionTitle:
                        'permission.tasks.can_set_visibility.shared',
                      permissionSubTitle: '',
                      type: 'radio',
                      permissions: [
                        {
                          permissionName: '',
                          requestScope: 'GLOBAL',
                          actionScopes: ['SHARED'],
                        },
                      ],
                      requestScope: 'GLOBAL',
                      permissionLevel: 'PROJECT',
                      isSelected: false,
                    },
                    {
                      id: uuidv4(),
                      permissionTitle:
                        'permission.tasks.can_set_visibility.both',
                      permissionSubTitle: '',
                      type: 'radio',
                      permissions: [
                        {
                          permissionName: '',
                          requestScope: 'GLOBAL',
                          actionScopes: ['PRIVATE', 'SHARED'],
                        },
                      ],
                      requestScope: 'GLOBAL',
                      permissionLevel: 'PROJECT',
                      isSelected: true,
                    },
                  ],
                },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.tasks.can_edit',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              dependentField: 0,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.assignee',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_ASSIGNEE:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.status',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_STATUS:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.start_and_due_date',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_DATES:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.name_and_description',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_DESCRIPTION:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE'],
                    },
                    // {
                    //   permissionName: 'TASK_DESCRIPTION:WRITE',
                    //   requestScope: 'GLOBAL',
                    //   actionScopes: [],
                    // },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.completed_on_date',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_COMPLETED_AT:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.started_on_date',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_ACTUAL_START:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.effort',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_EFFORT:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.progress',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_PROGRESS:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.priority',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_PRIORITY:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.convert_to_milestone',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_TYPE:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.mark_as_at_risk',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_AT_RISK:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.mark_as_private',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_PRIVACY:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.move_across_phases',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_UPDATE_PHASE:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.request_approval',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_REQUEST_APPROVAL:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.attachments',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_ATTACHMENT:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.create_subtasks',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'SUBTASK:CREATE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.create_dependencies',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_DEPENDENCY:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.tasks.can_delete',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              dependentField: 0,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName:
            'permission.projects.task_fields.view_task_field_values.title',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.projects.task_fields.view_task_field_values',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK_FIELD:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              isDependentOn: [1],
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.task_fields.view_task_field_values.same_account_permissions',
                //   permissionSubTitle:
                //     'permission.projects.task_fields.view_task_field_values.same_account_permissions.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                //   children: [],
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.task_fields.view_task_field_values.additional_field_sections',
                //   permissionSubTitle:
                //     'permission.task_fields.view_task_field_values.additional_field_sections.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                //   children: [],
                // },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.projects.task_fields.edit_task_field_values',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK_FIELD:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              dependentField: 0,
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.task_fields.edit_task_field_values.same_account_permissions',
                //   permissionSubTitle:
                //     'permission.projects.task_fields.edit_task_field_values.same_account_permissions.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                //   children: [],
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.projects.task_fields.edit_task_field_values.additional_field_sections',
                //   permissionSubTitle:
                //     'permission.task_fields.edit_task_field_values.additional_field_sections.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                //   showMultiSelect: {
                //     type: 'taskFields',
                //     selectedOptions: [],
                //   },
                //   children: [],
                // },
              ],
            },
          ],
        },
      ],
    },
    // Start of spaces permission set permissions
    {
      sectionHeaderName: 'projects.spaces',
      headerName: '',
      isAllSubSectionsDependsOnViewPermission: true,
      subSections: [
        {
          sectionHeaderName: 'permission.spaces.view',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.view.can_view_documents',
              permissionSubTitle:
                'permission.spaces.can_view_documents_subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              isMandatory: true,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'permission.spaces.edit',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.edit_can_edit_documents',
              permissionSubTitle:
                'permission.spaces.edit_can_edit_documents_subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'SPACE_TAB:WRITE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.spaces.edit_can_edit_embedded_document_url',
              permissionSubTitle:
                'permission.spaces.edit_can_edit_embedded_document_url_subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'SPACE_URL:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.edit_can_rearrange_documents',
              permissionSubTitle:
                'permission.spaces.edit_can_rearrange_documents_subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT_REARRANGE:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'create',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.can_create',
              permissionSubTitle: 'permission.spaces.can_create.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'SPACE:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.spaces.can_create.private',
                  permissionSubTitle:
                    'permission.spaces.can_create.private.subtitle',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.spaces.can_create.both',
                  permissionSubTitle:
                    'permission.spaces.can_create.both.subtitle',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE', 'SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.can_create_document',
              permissionSubTitle:
                'permission.spaces.can_create_document.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'SPACE_TAB:CREATE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.spaces.can_create_document.private',
                  permissionSubTitle:
                    'permission.spaces.can_create_document.private.subtitle',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.spaces.can_create_document.private.both',
                  permissionSubTitle:
                    'permission.spaces.can_create_document.private.both.subtitle',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE', 'SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.can_embed_document_url',
              permissionSubTitle:
                'permission.spaces.can_embed_document_url.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'SPACE_URL:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'delete',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.can_delete_space',
              permissionSubTitle: 'permission.spaces.can_delete_space.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'SPACE:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.can_delete_document',
              permissionSubTitle:
                'permission.spaces.can_delete_document.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'SPACE_TAB:DELETE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
          ],
        },
      ],
    },
    // Start of chat permission set permissions
    {
      sectionHeaderName: 'projects.tabs.chat',
      headerName: '',
      isAllSubSectionsDependsOnViewPermission: true,
      subSections: [
        {
          sectionHeaderName: 'permission.spaces.view',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_view_conversations',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              isMandatory: true,
              shouldDisable: false,
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle: 'permission.chat.can_view_all_conversations',
                //   permissionSubTitle:
                //     'permission.chat.can_view_all_conversations.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   isSelected: true,
                //   permissionLevel: 'PROJECT',
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.chat.can_view_associated_conversation',
                //   permissionSubTitle:
                //     'permission.chat.can_view_associated_conversation.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                // },
              ],
            },
          ],
        },
        {
          sectionHeaderName: 'permission.spaces.edit',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_send_messages',
              permissionSubTitle: 'permission.chat.can_send_messages.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION_COMMENT:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'COMMENT:DELETE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
                // {
                //   permissionName: 'COMMENT:WRITE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_invite_members',
              permissionSubTitle: 'permission.chat.can_invite_members.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION_ADD_MEMBER:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_edit_name_and_description',
              permissionSubTitle:
                'permission.chat.can_edit_name_and_description.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'create',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.chat.can_create_project_conversation',
              permissionSubTitle:
                'permission.chat.can_create_project_conversation.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.chat.can_create_private_conversation',
                  permissionSubTitle: '',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.chat.can_create_both_conversation',
                  permissionSubTitle: '',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE', 'SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                },
              ],
            },
          ],
        },
        {
          sectionHeaderName: 'delete',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_delete_conversation',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
          ],
        },
      ],
    },
    // Start of folders
    {
      sectionHeaderName: 'permission.folders',
      headerName: '',
      subSections: [
        {
          sectionHeaderName: '',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.folders.can_view_files_and_folders',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'FOLDER:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              isDependentOn: [1],
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.folders.can_create_folders_and_upload_files',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'FOLDER:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'FOLDER:WRITE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
                // {
                //   permissionName: 'FOLDER:DELETE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
                // {
                //   permissionName: 'ATTACHMENT:CREATE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              dependentField: 0,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.folders.can_create_folders_and_upload_files.private',
                  permissionSubTitle: '',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.folders.can_create_folders_and_upload_files.shared',
                  permissionSubTitle: '',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.folders.can_create_folders_and_upload_files.both',
                  permissionSubTitle: '',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE', 'SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
              ],
            },
          ],
        },
      ],
    },
    // start of project updates
    {
      sectionHeaderName: 'permission.project_updates',
      headerName: null,
      subSections: [
        {
          sectionHeaderName: '',
          headerName: '',
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.project_updates.can_view_updates',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'STATUS_UPDATE:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              isDependentOn: [1],
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.project_updates.can_create_and_publish_updates',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'STATUS_UPDATE:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'STATUS_UPDATE:WRITE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
                // {
                //   permissionName: 'STATUS_UPDATE_PUBLISH:CREATE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              dependentField: 0,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.project_updates.can_create_and_publish_updates.private',
                  permissionSubTitle: '',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                  children: [],
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.project_updates.can_create_and_publish_updates.shared',
                  permissionSubTitle: '',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: false,
                  children: [],
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.project_updates.can_create_and_publish_updates.both',
                  permissionSubTitle: '',
                  type: 'radio',
                  permissions: [
                    {
                      permissionName: '',
                      requestScope: 'GLOBAL',
                      actionScopes: ['PRIVATE', 'SHARED'],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
    // Start of key events and intervals permission set
    {
      sectionHeaderName: 'permission.key_events_and_intervals',
      headerName: '',
      isAllSubSectionsDependsOnViewPermission: false,
      subSections: [
        {
          sectionHeaderName: 'permission.key_events_and_intervals.field_values',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.key_events_and_intervals.field_values.can_view_key_events_field_values',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'KEY_EVENT_VALUE:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              isDependentOn: [1],
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.key_events_and_intervals.field_values.can_manage_key_events_field_values',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'KEY_EVENT_VALUE:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              dependentField: 0,
              children: [],
            },
          ],
        },
      ],
    },
    // Start of financials permission set
    {
      sectionHeaderName: 'permission.financials',
      headerName: '',
      isAllSubSectionsDependsOnViewPermission: false,
      subSections: [
        {
          sectionHeaderName: 'permission.spaces.view',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.financials.projects.view.can_view_financial_fields_and_numbers',
              permissionSubTitle:
                'permission.financials.projects.view.can_view_financial_fields_and_numbers.subtitle.project_level',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PROJECT_FINANCIALS:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.financials.projects.view.can_view_financial_fields_and_numbers.budgets_billrates_revenue',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PROJECT_BUDGET:READ',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                  shouldDisable: false,
                  slaves: [
                    {
                      sectionIndex: 8,
                      subSectionIndex: 0,
                      fieldIndex: [0],
                      childIndex: [1],
                      performOnChild: true,
                    },
                  ],
                  children: [],
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.financials.projects.view.can_view_financial_fields_and_numbers.cost_profit_and_margins',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PROJECT_PROFITABILITY:READ',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                  shouldDisable: false,
                  children: [],
                },
              ],
            },
          ],
        },
        {
          sectionHeaderName: 'permission.spaces.edit',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.financials.projects.edit.can_change_billing_type',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'BILLING_TYPE:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.financials.projects.edit.can_change_budgets',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PROJECT_BUDGET:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.financials.projects.edit.can_change_rate_cards',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PROJECT_RATE_CARD_UPDATE:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.financials.projects.edit.can_manually_override_bill_rates',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PROJECT_BILL_RATE_OVERRIDE:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'ACCOUNT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
          ],
        },
      ],
    },
  ];

export const actualDataForAccessibleNavItemsForProjectLevelPermissions = [
  {
    menuName: 'projects.title',
    menuIcon: Help16,
    route: '#projects',
  },
  {
    menuName: 'phase',
    menuIcon: Help16,
    route: '#phase',
  },
  {
    menuName: 'tasks',
    menuIcon: Help16,
    route: '#tasks',
  },
  {
    menuName: 'projects.tabs.spaces',
    menuIcon: Help16,
    route: '#spaces',
  },
  {
    menuName: 'projects.tabs.chat',
    menuIcon: Help16,
    route: '#chat',
  },
  {
    menuName: 'permission.folders',
    menuIcon: Help16,
    route: '#folders',
  },
  {
    menuName: 'permission.project_updates',
    menuIcon: Help16,
    route: '#statusUpdates',
  },
  {
    menuName: 'permission.key_events_and_intervals',
    menuIcon: Help16,
    route: '#key-events-and-intervals',
  },
  {
    menuName: 'permission.financials',
    menuIcon: Help16,
    route: '#financials',
  },
];

export const actualDataToRenderForCustomerLevelPermissionCreationScreen: Section[] =
  [
    {
      sectionHeaderName: 'projects.title',
      headerName: '',
      subSections: [
        {
          sectionHeaderName: '',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.customer.projects.can_invite_members',
              permissionSubTitle: '',
              type: 'checkbox',
              takeActionScopeFromItself: true,
              permissions: [
                {
                  permissionName: 'PROJECT_MEMBER:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: ['EXTERNAL'],
                },
              ],
              requestScope: 'GLOBAL',
              isSelected: true,
              permissionLevel: 'PROJECT',
              children: [],
            },
          ],
        },
      ],
    },
    // Start of phase related permissions
    {
      sectionHeaderName: 'phase',
      headerName: '',
      subSections: [
        {
          sectionHeaderName: '',
          headerName: null,
          fields: [
            // {
            //   id: uuidv4(),
            //   permissionTitle: 'permission.phase.can_create_phase',
            //   permissionSubTitle: '',
            //   type: 'checkbox',
            //   permissions: [
            //     {
            //       permissionName: 'PHASE:CREATE',
            //       requestScope: 'GLOBAL',
            //       actionScopes: [],
            //     },
            //   ],
            //   permissionLevel: 'PROJECT',
            //   requestScope: 'GLOBAL',
            //   isSelected: true,
            //   children: [],
            // },
            {
              id: uuidv4(),
              permissionTitle: 'permission.phase.edit.can_edit_phase',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PHASE:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.phase.edit.can_edit_phase_name',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PHASE_NAME:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.phase.edit.can_edit_phase_dates',
                  permissionSubTitle:
                    'permission.phase.edit.can_edit_phase_dates.subtitle',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'PHASE_DATE:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.phase.delete.can_delete_phases',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'PHASE:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
          ],
        },
      ],
    },
    // Start of tasks related permissions
    {
      sectionHeaderName: 'tasks',
      headerName: '',
      subSections: [
        {
          sectionHeaderName: '',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.tasks.can_view',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              isDependentOn: [1, 2],
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle: 'permission.tasks.can_view.all_tasks',
                //   permissionSubTitle:
                //     'permission.tasks.can_view.all_tasks_subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle: 'permission.tasks.can_view.assigned_tasks',
                //   permissionSubTitle:
                //     'permission.tasks.can_view.assigned_tasks_subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'RESTRICTED',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'RESTRICTED',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                // },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.tasks.can_edit',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              dependentField: 0,
              children: [
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.assignee',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_ASSIGNEE:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.status',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_STATUS:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.start_and_due_date',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_DATES:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.name_and_description',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_NAME:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                    // {
                    //   permissionName: 'TASK_DESCRIPTION:WRITE',
                    //   requestScope: 'GLOBAL',
                    //   actionScopes: [],
                    // },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.completed_on_date',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_COMPLETED_AT:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.started_on_date',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_ACTUAL_START:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.effort',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_EFFORT:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.progress',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_PROGRESS:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.priority',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_PRIORITY:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.mark_as_at_risk',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_AT_RISK:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                // {
                //   id: uuidv4(),
                //   permissionTitle: 'permission.tasks.can_edit.mark_as_private',
                //   permissionSubTitle: '',
                //   type: 'checkbox',
                //   permissions: [
                //     {
                //       permissionName: 'TASK_PRIVACY:WRITE',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                // },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.move_across_phases',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_UPDATE_PHASE:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.request_approval',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_REQUEST_APPROVAL:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.attachments',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_ATTACHMENT:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle: 'permission.tasks.can_edit.create_subtasks',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'SUBTASK:CREATE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                    // {
                    //   permissionName: 'SUBTASK:WRITE',
                    //   requestScope: 'GLOBAL',
                    //   actionScopes: [],
                    // },
                    // {
                    //   permissionName: 'SUBTASK:DELETE',
                    //   requestScope: 'GLOBAL',
                    //   actionScopes: [],
                    // },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
                {
                  id: uuidv4(),
                  permissionTitle:
                    'permission.tasks.can_edit.create_dependencies',
                  permissionSubTitle: '',
                  type: 'checkbox',
                  permissions: [
                    {
                      permissionName: 'TASK_DEPENDENCY:WRITE',
                      requestScope: 'GLOBAL',
                      actionScopes: [],
                    },
                  ],
                  requestScope: 'GLOBAL',
                  permissionLevel: 'PROJECT',
                  isSelected: true,
                },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.tasks.can_delete',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              dependentField: 0,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName:
            'permission.projects.task_fields.view_task_field_values.title',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.projects.task_fields.view_task_field_values',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK_FIELD:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.customer.tasks.task_fields.can_view_shared_fields',
                //   permissionSubTitle:
                //     'permission.customer.tasks.task_fields.can_view_shared_fields.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                //   children: [],
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.customer.tasks.task_fields.can_view_specific_fields',
                //   permissionSubTitle:
                //     'permission.customer.tasks.task_fields.can_view_specific_fields.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                //   children: [],
                // },
              ],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.projects.task_fields.edit_task_field_values',
              permissionSubTitle:
                'permission.projects.task_fields.edit_task_field_values.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'TASK_FIELD:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.customer.tasks.task_fields.can_edit_shared_fields',
                //   permissionSubTitle:
                //     'permission.customer.tasks.task_fields.can_edit_shared_fields.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: true,
                //   children: [],
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.customer.tasks.task_fields.can_edit_specific_fields',
                //   permissionSubTitle:
                //     'permission.customer.tasks.task_fields.can_edit_specific_fields.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                //   showMultiSelect: {
                //     type: 'taskFields',
                //     selectedOptions: [],
                //   },
                //   children: [],
                // },
              ],
            },
          ],
          notDependentOnAnyAboveSections: true,
        },
      ],
    },

    // Start of spaces permission set permissions
    {
      sectionHeaderName: 'projects.spaces',
      headerName: '',
      isAllSubSectionsDependsOnViewPermission: true,
      subSections: [
        {
          sectionHeaderName: 'permission.spaces.view',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.view.can_view_documents',
              permissionSubTitle:
                'permission.spaces.can_view_documents_subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'SPACE_TAB:READ',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              isMandatory: true,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'permission.spaces.edit',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.edit_can_edit_documents',
              permissionSubTitle:
                'permission.spaces.edit_can_edit_documents_subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'SPACE_TAB:WRITE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle:
                'permission.spaces.edit_can_edit_embedded_document_url',
              permissionSubTitle:
                'permission.spaces.edit_can_edit_embedded_document_url_subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'SPACE_URL:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.edit_can_rearrange_documents',
              permissionSubTitle:
                'permission.spaces.edit_can_rearrange_documents_subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT_REARRANGE:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'create',
          headerName: null,
          fields: [
            // {
            //   id: uuidv4(),
            //   permissionTitle: 'permission.spaces.can_create',
            //   permissionSubTitle: 'permission.spaces.can_create.subtitle',
            //   type: 'checkbox',
            //   permissions: [
            //     {
            //       permissionName: 'SPACE:CREATE',
            //       requestScope: 'GLOBAL',
            //       actionScopes: [],
            //     },
            //   ],
            //   requestScope: 'GLOBAL',
            //   permissionLevel: 'PROJECT',
            //   isSelected: true,
            //   children: [],
            // },
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.can_create_document',
              permissionSubTitle:
                'permission.spaces.can_create_document.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'SPACE_TAB:CREATE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.can_embed_document_url',
              permissionSubTitle:
                'permission.spaces.can_embed_document_url.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'SPACE_URL:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'delete',
          headerName: null,
          fields: [
            // {
            //   id: uuidv4(),
            //   permissionTitle: 'permission.spaces.can_delete_space',
            //   permissionSubTitle: 'permission.spaces.can_delete_space.subtitle',
            //   type: 'checkbox',
            //   permissions: [
            //     {
            //       permissionName: 'SPACE:DELETE',
            //       requestScope: 'GLOBAL',
            //       actionScopes: [],
            //     },
            //   ],
            //   requestScope: 'GLOBAL',
            //   permissionLevel: 'PROJECT',
            //   isSelected: true,
            //   children: [],
            // },
            {
              id: uuidv4(),
              permissionTitle: 'permission.spaces.can_delete_document',
              permissionSubTitle:
                'permission.spaces.can_delete_document.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'DOCUMENT:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'SPACE_TAB:DELETE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              children: [],
            },
          ],
        },
      ],
    },
    // Start of chat related permissions
    {
      sectionHeaderName: 'projects.tabs.chat',
      headerName: '',
      isAllSubSectionsDependsOnViewPermission: true,
      subSections: [
        {
          sectionHeaderName: 'permission.spaces.view',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_view_conversations',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION:READ',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              isMandatory: true,
              shouldDisable: false,
              // takeRequestScopeFromChild: true,
              children: [
                // {
                //   id: uuidv4(),
                //   permissionTitle: 'permission.chat.can_view_all_conversations',
                //   permissionSubTitle:
                //     'permission.chat.can_view_all_conversations.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'GLOBAL',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'GLOBAL',
                //   isSelected: true,
                //   permissionLevel: 'PROJECT',
                // },
                // {
                //   id: uuidv4(),
                //   permissionTitle:
                //     'permission.chat.can_view_associated_conversation',
                //   permissionSubTitle:
                //     'permission.chat.can_view_associated_conversation.subtitle',
                //   type: 'radio',
                //   permissions: [
                //     {
                //       permissionName: '',
                //       requestScope: 'RESTRICTED',
                //       actionScopes: [],
                //     },
                //   ],
                //   requestScope: 'RESTRICTED',
                //   permissionLevel: 'PROJECT',
                //   isSelected: false,
                // },
              ],
            },
          ],
        },
        {
          sectionHeaderName: 'permission.spaces.edit',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_send_messages',
              permissionSubTitle: 'permission.chat.can_send_messages.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION_COMMENT:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
                // {
                //   permissionName: 'COMMENT:DELETE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
                // {
                //   permissionName: 'COMMENT:WRITE',
                //   requestScope: 'GLOBAL',
                //   actionScopes: [],
                // },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_invite_members',
              permissionSubTitle: 'permission.chat.can_invite_members.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION_ADD_MEMBER:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_edit_name_and_description',
              permissionSubTitle:
                'permission.chat.can_edit_name_and_description.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION:WRITE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'create',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle:
                'permission.chat.can_create_project_conversation',
              permissionSubTitle:
                'permission.chat.can_create_project_conversation.subtitle',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION:CREATE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
          ],
        },
        {
          sectionHeaderName: 'delete',
          headerName: null,
          fields: [
            {
              id: uuidv4(),
              permissionTitle: 'permission.chat.can_delete_conversation',
              permissionSubTitle: '',
              type: 'checkbox',
              permissions: [
                {
                  permissionName: 'CONVERSATION:DELETE',
                  requestScope: 'GLOBAL',
                  actionScopes: [],
                },
              ],
              requestScope: 'GLOBAL',
              permissionLevel: 'PROJECT',
              isSelected: true,
              shouldDisable: false,
              children: [],
            },
          ],
        },
      ],
    },
  ];

export const actualDataForAccessibleNavItemsForCustomerLevelPermissions = [
  {
    menuName: 'projects.title',
    menuIcon: Help16,
    route: '#projects',
  },
  {
    menuName: 'phase',
    menuIcon: Help16,
    route: '#phase',
  },
  {
    menuName: 'tasks',
    menuIcon: Help16,
    route: '#tasks',
  },
  {
    menuName: 'projects.tabs.spaces',
    menuIcon: Help16,
    route: '#spaces',
  },
  {
    menuName: 'projects.tabs.chat',
    menuIcon: Help16,
    route: '#chat',
  },
];

const cachedData = {};

function getCachedData(key: NewPermissionSetTypes): {
  data: Section[];
  navItems: NavItems[];
} {
  if (cachedData[key]) {
    return cachedData[key];
  }

  let data: Section[] = [];
  let navItems: NavItems[] = [];

  if (key === NewPermissionSetTypes.AccountLevel) {
    data = [...actualDataToRenderForPermissionCreationScreen];
    navItems = [...actualDataForAccessibleNavItems];
  } else if (key === NewPermissionSetTypes.CustomerLevel) {
    data = [...actualDataToRenderForCustomerLevelPermissionCreationScreen];
    navItems = [...actualDataForAccessibleNavItemsForCustomerLevelPermissions];
  } else {
    data = [...actualDataToRenderForProjectsLevelPermissionCreationScreen];
    navItems = [...actualDataForAccessibleNavItemsForProjectLevelPermissions];
  }

  cachedData[key] = { data, navItems };

  return { data, navItems };
}

export const dataToRenderForPermissionCreationScreen = getCachedData(
  NewPermissionSetTypes.AccountLevel,
).data;

export const accessibleNavItems = getCachedData(
  NewPermissionSetTypes.AccountLevel,
).navItems;

export const dataToRenderForProjectsLevelPermissionCreationScreen =
  getCachedData(NewPermissionSetTypes.ProjectLevel).data;

export const accessibleNavItemsForProjectLevelPermissions = getCachedData(
  NewPermissionSetTypes.ProjectLevel,
).navItems;

export const dataToRenderForCustomerLevelPermissionCreationScreen =
  getCachedData(NewPermissionSetTypes.CustomerLevel).data;

export const accessibleNavItemsForCustomerLevelPermissions = getCachedData(
  NewPermissionSetTypes.CustomerLevel,
).navItems;
